// src/components/form/fields/SelectField.tsx
import React from 'react';
import { Select } from 'antd';
import { useFormikContext } from 'formik';
import { FormFieldWrapper } from './FormFieldWrapper';
import { FieldInfoMessage } from './FieldInfoMessage';

export const SelectField = ({ name, label, options, disabled, placeholder, infoMessage, required }: any) => {
  const { handleChange, values, setFieldValue } = useFormikContext<any>();
  
  const handleSelectChange = (value: string) => {
    // Handle normal field change
    handleChange({ target: { name, value } });
    
    // Special handling for category field - auto-fill category levels
    if (name === 'category' && value) {
      const categoryParts = value.split(' > ').map(part => part.trim());
      
      // Auto-fill the 4 category levels
      setFieldValue('catL1', categoryParts[0] || '');
      setFieldValue('catL2', categoryParts[1] || '');
      setFieldValue('catL3', categoryParts[2] || '');
      setFieldValue('catL4', categoryParts[3] || '');
    } else if (name === 'category' && !value) {
      // Clear category levels if category is cleared
      setFieldValue('catL1', '');
      setFieldValue('catL2', '');
      setFieldValue('catL3', '');
      setFieldValue('catL4', '');
    }
  };

  return (
    <FormFieldWrapper name={name} label={label} required={required}>
      <Select 
        value={values[name]}
        onChange={handleSelectChange}
        disabled={disabled}
        placeholder={placeholder}
        options={options}
        showSearch
        filterOption={(input, option) =>
          String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        className="rounded-xl border-gray-200 hover:border-blue-300 focus:border-blue-500 focus:shadow-lg transition-all duration-200 text-base"
      />
      {infoMessage && <FieldInfoMessage message={infoMessage} />}
    </FormFieldWrapper>
  );
};
